(function() {
    'use strict';
    function MwBeatsHeaderController($scope, $element) {
        this.clickedBeat = function clickedBeat(beat, indexOfBeat) {
            this.beats.splice(indexOfBeat, 1);

            this.selectedBeat({beat: beat});
        };

        this.dismiss = function dismiss() {
            $element.hide();
        };
    }

    angular
        .module('MW.ContactManager.MwBeatsHeader', [])
        .component('mwBeatsHeader', {
            bindings: {
                beats: '<',
                selectedBeat: '&'
            },
            controller: ['$scope', '$element', MwBeatsHeaderController],
            template: `
                <div ng-if="$ctrl.beats.length" class="wrapper" layout="row" layout-align="space-between center">
                    <md-icon class="help-icon" md-svg-icon="action:ic_help_24px"></md-icon>
                    <div class="help-text">
                        <span translate>icm-search__did-you-mean--beats-message</span>
                        <span class="beat-name" ng-repeat="$item in $ctrl.beats" ng-click="$ctrl.clickedBeat($item, $index)">{{$item.display}}</span>
                    </div>
                    <md-icon class="dismiss-icon" ng-click="$ctrl.dismiss()" md-svg-icon="content:ic_clear_24px"></md-icon>
                </div>
            `
        });
}());
